import React from 'react';
import { useNavigate } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch } from 'store';
import { INewsItem } from 'store/slices/news/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import { saveNewsItem, saveNewsItemAsDraft } from 'store/slices/news/actions';
import { prepareContent } from 'components/form/Content/utils';
import { StatusesEnum } from 'constants/status';
import { LangEnum } from 'constants/lang';
import { DEFAULT_SEO_STATE } from 'constants/seo';

import { NewsForm } from './components/NewsForm';

export const Add = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onFinish = (values: INewsItem) => {
    setIsLoading(true);
    dispatch(saveNewsItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/news');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: INewsItem) => {
    setIsLoading(true);
    dispatch(saveNewsItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/news');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/news');
  };

  return (
    <MainLayout pageTitle='Создание'>
      <NewsForm
        onFinish={onFinish}
        onSaveDraft={onSaveDraft}
        cancelButtonHandler={cancelButtonHandler}
        isDraft
        isLoading={isLoading}
        initialValues={{
          ...DEFAULT_SEO_STATE,
          content: prepareContent([]),
          image: null,
          intro: '',
          lang: LangEnum.ru,
          name: '',
          region: null,
          shortDescription: '',
          source: '',
          sourceLink: '',
          status: StatusesEnum.PUBLISHED,
          tags: [],
          topic: null,
        }}
      />
    </MainLayout>
  );
};
